import React from 'react';
import { LoginSection } from './section/loginSection.js';
import { ExerciseSection } from './section/exerciseSection.js';
import { BackupSection } from './section/beckupSection.js';
import { CardioSection } from './section/cardioSection.js';
import { useAppContext } from '../../0_context/AppContext.js';

export default function SettingsPage({ isActive }) {
  const {
    newExerciseName, setNewExerciseName,
    addExerciseLabel, exerciseList,
    removeExercise,
    exportDataAsJson, jsonExchangeArea, setJsonExchangeArea, importDataFromJson,
    newCardioName, setNewCardioName, newCardioUnit, setNewCardioUnit,
    addCardioLabel, cardioList, removeCardio,
    user, syncMessage, handleGoogleLogin, handleLogout, 
    backupToCloud, fetchFromCloud
  } = useAppContext();

  if (!isActive) return null;

  return (
    <section id="page-settings" className="page active max-w-md mx-auto text-left">
      
      {/* ================= 구글 로그인 & 클라우드 동기화 패널 ================= */}
      <LoginSection 
        user={user}
        handleGoogleLogin={handleGoogleLogin}
        handleLogout={handleLogout}
        backupToCloud={backupToCloud}
        fetchFromCloud={fetchFromCloud}
        syncMessage={syncMessage}
      />

      {/* ================= 운동 종목 관리 ================= */}
      {/* - 유산소 */}
      <CardioSection 
          newCardioName={newCardioName}
          setNewCardioName={setNewCardioName}
          newCardioUnit={newCardioUnit}
          setNewCardioUnit={setNewCardioUnit}
          addCardioLabel={addCardioLabel}
          cardioList={cardioList}
          removeCardio={removeCardio}
      />
      {/* - 무산소 */}
      <ExerciseSection 
        newExerciseName={newExerciseName}
        setNewExerciseName={setNewExerciseName}
        addExerciseLabel={addExerciseLabel}
        exerciseList={exerciseList}
        removeExercise={removeExercise}
      />

      {/* ================= 수동 데이터 내보내기 및 복구 ================= */}
      <BackupSection 
        user={user}
        exportDataAsJson={exportDataAsJson}
        jsonExchangeArea={jsonExchangeArea}
        setJsonExchangeArea={setJsonExchangeArea}
        importDataFromJson={importDataFromJson}
      />
    </section>
  );
}